module.exports = __webpack_public_path__ + "img/Fresh.a50b25ea.png";